import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row date-navigator mt-3 mb-3" }
const _hoisted_2 = { class: "col-2" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "col-8" }
const _hoisted_7 = { class: "date-header" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row sort-and-filter mt-3 mb-3" }
const _hoisted_12 = { class: "col right" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn dropdown-toggle",
  type: "button",
  id: "parkFilterButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, "Park Filter", -1)
const _hoisted_15 = {
  class: "dropdown-menu",
  "aria-labelledby": "parkFilterButton"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"desktop-only\"><div class=\"cal-week-legend-row\"><div class=\"cal-week-legend-cell\">Sun</div><div class=\"cal-week-legend-cell\">Mon</div><div class=\"cal-week-legend-cell\">Tue</div><div class=\"cal-week-legend-cell\">Wed</div><div class=\"cal-week-legend-cell\">Thu</div><div class=\"cal-week-legend-cell\">Fri</div><div class=\"cal-week-legend-cell\">Sat</div></div></div>", 1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"left"} }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CalendarDayPrevious = _resolveComponent("CalendarDayPrevious")!
  const _component_CalendarDayCurrent = _resolveComponent("CalendarDayCurrent")!
  const _component_CalendarDayFuture = _resolveComponent("CalendarDayFuture")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "btn",
          disabled: !_ctx.canMovePrevMonth,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moveToPrevMonth && _ctx.moveToPrevMonth(...args)))
        }, _hoisted_5, 8, _hoisted_3)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.monthName), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveToNextMonth && _ctx.moveToNextMonth(...args)))
        }, _hoisted_10)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeCalendarFilter(null)))
            }, "All"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operatingCalendars, (opCal) => {
              return (_openBlock(), _createElementBlock("button", {
                class: "dropdown-item",
                type: "button",
                key: opCal.operatingExtCalendarId,
                onClick: ($event: any) => (_ctx.changeCalendarFilter(opCal.operatingExtCalendarId))
              }, _toDisplayString(opCal.displayName), 9, _hoisted_16))
            }), 128))
          ])
        ])
      ])
    ]),
    _hoisted_17,
    _createElementVNode("div", {
      class: _normalizeClass({ 'loading': _ctx.isLoading })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priorDays, (dt) => {
        return (_openBlock(), _createBlock(_component_CalendarDayPrevious, {
          key: dt,
          day: dt
        }, null, 8, ["day"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentDays, (operatingDay) => {
        return (_openBlock(), _createBlock(_component_CalendarDayCurrent, {
          key: operatingDay.calendarDate,
          operatingDay: operatingDay
        }, null, 8, ["operatingDay"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.futureDays, (dt) => {
        return (_openBlock(), _createBlock(_component_CalendarDayFuture, {
          key: dt,
          day: dt
        }, null, 8, ["day"]))
      }), 128)),
      _hoisted_18
    ], 2)
  ]))
}